function hideDefaultVariants() {
  document.querySelectorAll('.xb-list-style__variant-wrapper').forEach(function(wrapper) {
    var select = wrapper.querySelector('select');
    if (select && select.options.length === 1 && select.options[0].text.trim() === 'Default') {
      wrapper.style.display = 'none';
    }
  });
}

setTimeout(hideDefaultVariants, 500);
setTimeout(hideDefaultVariants, 1500);
setTimeout(hideDefaultVariants, 3000);

const observer = new MutationObserver(hideDefaultVariants);
observer.observe(document.body, { childList: true, subtree: true });
